import { IAccountingUnit, Page } from '@monorepo/interfaces';
import { Action, Selector, State } from '@ngxs/store';
import type { StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { AccountingUnitService } from '../../services/accounting-unit.service';
import { LoadAccountingUnits } from './accounting-unit.actions';
import { finalize, Observable, tap } from 'rxjs';

import { HttpErrorResponse } from '@angular/common/http';

export interface AccountingUnitStateModel {
    accountingUnits: IAccountingUnit[];
    isLoading: boolean;
}

@State<AccountingUnitStateModel>({
    name: 'accountingUnit',
    defaults: {
        accountingUnits: [],
        isLoading: false
    }
})
@Injectable()
export class AccountingUnitState {
    private accountingUnitService = inject(AccountingUnitService);

    @Selector()
    static accountingUnits(state: AccountingUnitStateModel): IAccountingUnit[] {
        return state.accountingUnits;
    }

    @Selector()
    static isLoading(state: AccountingUnitStateModel): boolean {
        return state.isLoading;
    }

    @Action(LoadAccountingUnits)
    loadAccountingUnits(
        ctx: StateContext<AccountingUnitStateModel>
    ): Observable<Page<IAccountingUnit> | HttpErrorResponse> {
        this.setIsLoading(ctx, true);
        return this.accountingUnitService.getAllPaginated(0, 0).pipe(
            tap(paginatedAccountingUnits => ctx.patchState({ accountingUnits: paginatedAccountingUnits.items })),
            finalize(() => this.setIsLoading(ctx, false))
        );
    }

    private setIsLoading(ctx: StateContext<AccountingUnitStateModel>, isLoading: boolean): void {
        ctx.patchState({ isLoading });
    }
}
